enum ProductType {
  ASS_BRPT = 'ASS_BRPT',
  ADV_RPT = 'ADV_RPT',
  ASS_ARPT = 'ASS_ARPT',
  NO_REPORT = 'NO_REPORT',
}

enum PriceKeyMap {
  ASS_BRPT = 'assessmentPrice',
  ADV_RPT = 'advancedReportPrice',
  ASS_ARPT = 'assessmentWithAdvancedReportPrice',
  NO_REPORT = 'assessmentPrice',
}

enum CheckoutType {
  TEACHER_ASSESSMENT = 'TEACHER_ASSESSMENT',
  TEACHER_REPORT = 'TEACHER_REPORT',
  INSTITUTE_BULK_ASSESSMENT = 'INSTITUTE_BULK_ASSESSMENT',
}

enum OtpType {
  TEACHER_REGISTER = 'teacher_register',
  INSTITUTE_REGISTER = 'institute_register',
  POC_INSTITUTE_REGISTER = 'poc_institute_register',
  INSTITUTE_LOGIN = 'institute_login',
  TEACHER_LOGIN = 'teacher_login',
  TEACHER_AUTH = 'teacher_auth',
  SALES_ADMIN_AUTH = 'sales_admin_auth',
  FINANCE_ADMIN_AUTH = 'finance_admin_auth',
  SALES_ADMIN_REGISTER = 'sales_admin_register',
  FINANCE_ADMIN_REGISTER = 'finance_admin_register',
  SALES_REGISTER = 'sales_register',
  FINANCE_REGISTER = 'finance_register',
  SALES_LOGIN = 'sales_login',
  FINANCE_LOGIN = 'finance_login',
  ENTITY_ADMIN_LOGIN = 'entity_admin_login',
}

enum BuyAssessmentAction {
  BUY_NOW = 'buy_now',
  ADD_TO_CART = 'add_to_cart'
}

enum AssessmentAttributes {
  REPORT = 'report',
  LEVELS_SUBJECTS = 'levels_subjects',
  PROFICIENCY_LEVEL = 'proficiency_level',
  LEVELS = 'levels'
}

enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

enum HighestQualificationEnum {
  BACHELORS = 'Bachelors',
  MASTERS = 'Masters',
  DOCTORATE = 'Doctorate',
  POST_DOCTORATE = 'Post-Doctorate',
} 
// Sync with stores Collection
enum StoresSlugEnum {
  IITED = 'ii-ted',
  OLYMPIADS = 'olympiads',
  LEARNINGS = 'learnings',
  IWSA = 'iwsa',
}
// Sync with stores Collection
const StoreEnum = [
  {
    slug: 'ii-ted',
    label: 'Assessment'
  },
  {
    slug: 'olympiads',
    label: 'Olympiad'
  },
  {
    slug: 'learnings',
    label: 'Learnings'
  },
  {
    slug: 'iwsa',
    label: 'Learnings'
  }
] as const;

enum AssessmentReportType {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
  CERTIFICATE = 'CERTIFICATE',
}

enum AssessmentSlug {
  EPA = "educator-proficiency-assessment",
  CS = "communication-skills",
  DL = "digital-literacy",
  GTO = "global-teachers-olympiad-2025",
  PSY = "psychometry-for-teachers",
  AIE = "ai-for-educators",
  HLI = "hubblehox-leadership-insights",
}

enum AssessmentButtonEnum {
  BUY_ASSESSMENT = "buy_assessment",
  START_ASSESSMENT = "start_assessment",
  VIEW_RESULT = "view_result",
}

enum ExamWindowStatusEnum {
  BEFORE = "before",
  WITHIN = "within",
  AFTER = "after",
}

enum AssessmentStatusEnum {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

enum AssessmentCodeEnum {
  EPA = "EP",
  CS = "CS",
  DL = "DL",
  GTO = "GTO",
  PSY = "PSY",
  HLI = "HLI",
}

enum TabsQueryParamsEnum {
  MY_ASSESSMENTS = 'my-assessments',
  MY_OLYMPIADS = 'my-olympiads',
  MY_LEARNINGS = 'my-learnings',
}

enum ClientSlugEnum {
  IITED = 'ii-ted',
  IWSA = 'iwsa',
}

enum ReportNameEnum {
  BASIC_REPORT = 'Basic Report',
  ADVANCED_REPORT = 'Advanced Report',
}

enum OrgSlugEnum {
  SVKM = 'svkm',
  SES = 'ses',
  VGOS = 'vgos',
  MSBTE = 'msbte',
  SGBS = 'sgbs',
  CNMS = 'cnms',
  JDA = 'jda',
  LHL_CPS = 'lhl-cps',
  LHL_BHIS = 'lhl-bhis',
  LHL_PG = 'lhl-pg',
  LHL_HERITAGE = 'lhl-heritage',
}

const CouponCodeEnum = ["AIE50", "SVKM5K", "SGBS50", "CNM5K", "JNDA50", "LHL50", "BHIS50", "PG50", "HIXS50"] as const;

export {
  PriceKeyMap,
  ProductType,
  CheckoutType,
  OtpType,
  BuyAssessmentAction,
  AssessmentAttributes,
  PaymentStatus,
  HighestQualificationEnum,
  StoresSlugEnum,
  StoreEnum,
  AssessmentReportType,
  AssessmentSlug,
  AssessmentButtonEnum,
  ExamWindowStatusEnum,
  AssessmentStatusEnum,
  AssessmentCodeEnum,
  TabsQueryParamsEnum,
  ClientSlugEnum,
  ReportNameEnum,
  OrgSlugEnum,
  CouponCodeEnum,
}